<template>
    <SelectDropDown
            :id="id"
            :name="name"
            :label="label"
            @selection-change="teamSelected"
            :options="teams"
            :defaultSelected="defaultSelected ? {id: defaultSelected.id} : teams[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import teamService from "@/services/team.service";

    export default {
        name: "TeamDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String,
            label: String,
            defaultSelected: Object
        },
        created() {
            teamService.fetchTeams()
                .then(({data}) => {
                    this.teams.push({
                        id: 'none',
                        name: '(всички)'
                    });
                    data.forEach(team => this.teams.push(team));
                });
        },
        data() {
            return {
                teams: []
            }
        },
        methods: {
            teamSelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValueId: value.currentValue ? value.currentValue.id === 'none' ? '' : value.currentValue.id : '',
                    currentValue: value.currentValue ? value.currentValue.id === 'none' ? '' : value.currentValue.name : '',
                    oldValue: value.oldValue
                });
            }
        }
    }
</script>

<style scoped>

</style>
